/**
 * ECOMLISTO CHATBOT - Embed Script
 * Self-contained script for easy Webflow integration
 * 
 * Usage:
 * <script src="chatbot-embed.js" 
 *   data-webhook="https://your-n8n.com/webhook/xxx"
 *   data-bot-name="Your Bot Name"
 *   data-welcome-message="Hello! How can I help?">
 * </script>
 */

(function () {
    'use strict';

    // ============================================
    // INLINE CSS (minified)
    // ============================================
    const CSS = `
:root{--echat-primary:linear-gradient(135deg,#667eea 0%,#764ba2 100%);--echat-primary-solid:#667eea;--echat-secondary:#1a1a2e;--echat-accent:#00d4ff;--echat-bg-light:rgba(255,255,255,0.95);--echat-bg-glass:rgba(255,255,255,0.85);--echat-text-dark:#1a1a2e;--echat-text-light:#fff;--echat-text-muted:#6b7280;--echat-shadow:0 25px 50px -12px rgba(0,0,0,0.25);--echat-shadow-sm:0 4px 15px rgba(0,0,0,0.1);--echat-radius:20px;--echat-bubble-size:65px;--echat-transition:all .3s cubic-bezier(.4,0,.2,1)}.echat-widget *{margin:0;padding:0;box-sizing:border-box;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}.echat-bubble{position:fixed;bottom:25px;right:25px;width:var(--echat-bubble-size);height:var(--echat-bubble-size);border-radius:50%;background:var(--echat-primary);cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:var(--echat-shadow);transition:var(--echat-transition);z-index:999998;border:none;outline:none}.echat-bubble:hover{transform:scale(1.1);box-shadow:0 30px 60px -15px rgba(102,126,234,0.5)}.echat-bubble:active{transform:scale(0.95)}.echat-bubble::before{content:'';position:absolute;width:100%;height:100%;border-radius:50%;background:var(--echat-primary);animation:echat-pulse 2s ease-out infinite;z-index:-1}@keyframes echat-pulse{0%{transform:scale(1);opacity:0.5}100%{transform:scale(1.6);opacity:0}}.echat-bubble-icon{width:28px;height:28px;fill:var(--echat-text-light);transition:var(--echat-transition)}.echat-bubble-img{width:100%;height:100%;object-fit:cover;border-radius:50%;transition:var(--echat-transition)}.echat-bubble.active .echat-bubble-img{display:none}.echat-bubble-icon.close{display:none}.echat-bubble.active .echat-bubble-icon.chat{display:none}.echat-bubble.active .echat-bubble-icon.close{display:block}.echat-bubble.active::before{display:none}.echat-badge{position:absolute;top:-5px;right:-5px;width:22px;height:22px;background:#ef4444;border-radius:50%;color:#fff;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center;border:2px solid #fff;animation:echat-bounce 1s ease infinite}@keyframes echat-bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-3px)}}.echat-teaser{position:fixed;bottom:calc(25px + var(--echat-bubble-size) + 14px);right:25px;max-width:220px;background:#fff;color:var(--echat-text-dark);padding:12px 34px 12px 16px;border-radius:16px;box-shadow:var(--echat-shadow-sm);font-size:14px;line-height:1.4;cursor:pointer;z-index:999998;opacity:0;visibility:hidden;transform:translateY(10px) scale(0.95);transform-origin:bottom right;transition:var(--echat-transition)}.echat-teaser.show{opacity:1;visibility:visible;transform:translateY(0) scale(1)}.echat-teaser::after{content:'';position:absolute;bottom:-6px;right:26px;width:14px;height:14px;background:#fff;transform:rotate(45deg);border-radius:0 0 3px 0}.echat-teaser-close{position:absolute;top:4px;right:8px;background:none;border:none;font-size:18px;line-height:1;color:var(--echat-text-muted);cursor:pointer;padding:2px;opacity:0.6;transition:var(--echat-transition)}.echat-teaser-close:hover{opacity:1}.echat-container{position:fixed;bottom:100px;right:25px;width:380px;max-width:calc(100vw - 40px);height:550px;max-height:calc(100vh - 140px);background:var(--echat-bg-glass);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-radius:var(--echat-radius);box-shadow:var(--echat-shadow);display:flex;flex-direction:column;overflow:hidden;z-index:999999;opacity:0;visibility:hidden;transform:translateY(20px) scale(0.95);transition:var(--echat-transition);border:1px solid rgba(255,255,255,0.2)}.echat-container.active{opacity:1;visibility:visible;transform:translateY(0) scale(1)}.echat-header{background:var(--echat-primary);padding:20px;display:flex;align-items:center;gap:12px;color:var(--echat-text-light);position:relative}.echat-avatar{width:45px;height:45px;border-radius:50%;background:rgba(255,255,255,0.2);display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0;overflow:hidden}.echat-avatar-img{width:100%;height:100%;object-fit:cover;border-radius:50%}.echat-header-info{flex:1}.echat-bot-name{font-size:16px;font-weight:600;margin-bottom:3px}.echat-bot-status{font-size:12px;opacity:0.9;display:flex;align-items:center;gap:6px}.echat-status-dot{width:8px;height:8px;background:#4ade80;border-radius:50%;animation:echat-blink 2s ease-in-out infinite}@keyframes echat-blink{0%,100%{opacity:1}50%{opacity:0.5}}.echat-close-btn{width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.15);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:var(--echat-transition)}.echat-close-btn:hover{background:rgba(255,255,255,0.25);transform:rotate(90deg)}.echat-close-btn svg{width:16px;height:16px;fill:#fff}.echat-messages{flex:1;overflow-y:auto;padding:20px;display:flex;flex-direction:column;gap:16px;background:linear-gradient(180deg,rgba(249,250,251,0.8) 0%,rgba(255,255,255,0.9) 100%)}.echat-messages::-webkit-scrollbar{width:6px}.echat-messages::-webkit-scrollbar-track{background:transparent}.echat-messages::-webkit-scrollbar-thumb{background:rgba(102,126,234,0.3);border-radius:10px}.echat-messages::-webkit-scrollbar-thumb:hover{background:rgba(102,126,234,0.5)}.echat-message{display:flex;gap:10px;max-width:85%;animation:echat-fadeIn .3s ease}@keyframes echat-fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.echat-message.bot{align-self:flex-start}.echat-message.user{align-self:flex-end;flex-direction:row-reverse}.echat-message-avatar{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0;overflow:hidden}.echat-message.bot .echat-message-avatar{background:var(--echat-primary);color:#fff}.echat-message.user .echat-message-avatar{background:var(--echat-secondary);color:#fff}.echat-message-content{padding:14px 18px;border-radius:18px;font-size:14px;line-height:1.5;word-wrap:break-word}.echat-message.bot .echat-message-content{background:#fff;color:var(--echat-text-dark);border-bottom-left-radius:6px;box-shadow:var(--echat-shadow-sm)}.echat-message.user .echat-message-content{background:var(--echat-primary);color:var(--echat-text-light);border-bottom-right-radius:6px}.echat-message.bot .echat-message-content .echat-link{color:var(--echat-primary-solid);text-decoration:underline;font-weight:500;transition:opacity .2s ease}.echat-message.bot .echat-message-content .echat-link:hover{opacity:0.8}.echat-message.user .echat-message-content .echat-link{color:#fff;text-decoration:underline;font-weight:500}.echat-typing{display:flex;gap:10px;align-items:center;padding:0 20px 15px}.echat-typing-avatar{width:32px;height:32px;border-radius:50%;background:var(--echat-primary);display:flex;align-items:center;justify-content:center;font-size:14px;overflow:hidden}.echat-typing-dots{background:#fff;padding:14px 18px;border-radius:18px;border-bottom-left-radius:6px;box-shadow:var(--echat-shadow-sm);display:flex;gap:5px;align-items:center}.echat-typing-dot{width:8px;height:8px;background:var(--echat-primary-solid);border-radius:50%;animation:echat-typing 1.4s ease-in-out infinite}.echat-typing-dot:nth-child(2){animation-delay:.2s}.echat-typing-dot:nth-child(3){animation-delay:.4s}@keyframes echat-typing{0%,60%,100%{transform:translateY(0);opacity:0.4}30%{transform:translateY(-8px);opacity:1}}.echat-input-area{padding:16px 20px;background:#fff;border-top:1px solid rgba(0,0,0,0.05);display:flex;gap:12px;align-items:center}.echat-input{flex:1;padding:14px 18px;border:2px solid rgba(102,126,234,0.2);border-radius:25px;font-size:14px;outline:none;transition:var(--echat-transition);background:rgba(249,250,251,0.8);color:var(--echat-text-dark)}.echat-input:focus{border-color:var(--echat-primary-solid);background:#fff;box-shadow:0 0 0 4px rgba(102,126,234,0.1)}.echat-input::placeholder{color:var(--echat-text-muted)}.echat-send-btn{width:48px;height:48px;border-radius:50%;background:var(--echat-primary);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:var(--echat-transition);flex-shrink:0}.echat-send-btn:hover{transform:scale(1.1);box-shadow:0 8px 20px rgba(102,126,234,0.4)}.echat-send-btn:active{transform:scale(0.95)}.echat-send-btn:disabled{opacity:0.5;cursor:not-allowed;transform:none}.echat-send-btn svg{width:20px;height:20px;fill:#fff;margin-left:2px}.echat-powered{padding:10px 20px;text-align:center;font-size:11px;color:var(--echat-text-muted);background:rgba(249,250,251,0.9)}.echat-powered a{color:var(--echat-primary-solid);text-decoration:none;font-weight:500}@media(max-width:480px){.echat-bubble{bottom:15px;right:15px;width:58px;height:58px}.echat-teaser{bottom:calc(15px + 58px + 12px);right:15px;max-width:calc(100vw - 90px)}.echat-container{bottom:85px;right:10px;left:10px;width:auto;max-width:none;height:calc(100vh - 110px);max-height:none;border-radius:16px}.echat-header{padding:16px}.echat-messages{padding:15px;gap:12px}.echat-message{max-width:90%}.echat-input-area{padding:12px 15px}.echat-input{padding:12px 16px;font-size:16px}}@media(prefers-color-scheme:dark){.echat-container{background:rgba(26,26,46,0.95);border-color:rgba(255,255,255,0.1)}.echat-messages{background:linear-gradient(180deg,rgba(26,26,46,0.8) 0%,rgba(26,26,46,0.95) 100%)}.echat-message.bot .echat-message-content{background:rgba(255,255,255,0.1);color:var(--echat-text-light)}.echat-typing-dots{background:rgba(255,255,255,0.1)}.echat-input-area{background:rgba(26,26,46,0.95);border-top-color:rgba(255,255,255,0.1)}.echat-input{background:rgba(255,255,255,0.1);border-color:rgba(102,126,234,0.3);color:var(--echat-text-light)}.echat-input:focus{background:rgba(255,255,255,0.15)}.echat-powered{background:rgba(26,26,46,0.95);color:rgba(255,255,255,0.5)}.echat-teaser{background:rgba(26,26,46,0.97);color:var(--echat-text-light)}.echat-teaser::after{background:rgba(26,26,46,0.97)}}
  `;

    // ============================================
    // CHATBOT CLASS
    // ============================================
    class EcomlistoChat {
        constructor(config = {}) {
            this.config = {
                webhookUrl: config.webhookUrl || '',
                botName: config.botName || 'Asistente Ecomlisto',
                botEmoji: config.botEmoji || '🤖',
                botImage: config.botImage || '',
                userEmoji: config.userEmoji || '👤',
                userImage: config.userImage || '',
                bubbleImage: config.bubbleImage || '',
                welcomeMessage: config.welcomeMessage || '¡Hola! 👋 Soy el asistente de Ecomlisto. ¿En qué puedo ayudarte hoy?',
                placeholder: config.placeholder || 'Escribe tu mensaje...',
                poweredBy: config.poweredBy !== false,
                teaserMessages: config.teaserMessages || [
                    '¿Buscas algo en especial? 🛍️',
                    '¡Tenemos combos a tu medida! 🌟',
                    '¿Te ayudo a elegir? 😊',
                    '¡Pregúntame por las ofertas! ✨'
                ],
                ...config
            };

            this.isOpen = false;
            this.isTyping = false;
            this.messages = [];
            this.sessionId = this.generateSessionId();
            this.hasShownWelcome = false;
            this.unreadCount = 0;

            // Estado del ciclo de bocadillos (teasers)
            this.teaserMinDelay = 5000;
            this.teaserMaxDelay = 15000;
            this.teaserVisibleDuration = 4000;
            this.teaserStopped = false;
            this.lastTeaserIndex = -1;
            this.teaserTimer = null;

            this.init();
        }

        generateSessionId() {
            return 'echat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        }

        init() {
            this.injectStyles();
            this.injectFonts();
            this.createWidget();
            this.attachEventListeners();
            this.startTeaserCycle();
        }

        injectFonts() {
            if (document.getElementById('echat-fonts')) return;

            const link = document.createElement('link');
            link.id = 'echat-fonts';
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap';
            document.head.appendChild(link);
        }

        injectStyles() {
            if (document.getElementById('echat-styles')) return;

            const style = document.createElement('style');
            style.id = 'echat-styles';
            style.textContent = CSS;
            document.head.appendChild(style);
        }

        createWidget() {
            const widget = document.createElement('div');
            widget.className = 'echat-widget';
            widget.id = 'echat-widget';

            widget.innerHTML = `
        <button class="echat-bubble" id="echat-bubble" aria-label="Abrir chat">
          ${this.config.bubbleImage
            ? `<img src="${this.config.bubbleImage}" alt="Abrir chat" class="echat-bubble-img chat"/>`
            : `<svg class="echat-bubble-icon chat" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z"/>
            <path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/>
          </svg>`}
          <svg class="echat-bubble-icon close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
          </svg>
          <span class="echat-badge" id="echat-badge" style="display: none;">1</span>
        </button>
        <div class="echat-teaser" id="echat-teaser" role="button" tabindex="0" aria-label="Abrir chat">
          <button class="echat-teaser-close" id="echat-teaser-close" aria-label="Cerrar aviso">&times;</button>
          <span class="echat-teaser-text" id="echat-teaser-text"></span>
        </div>
        <div class="echat-container" id="echat-container">
          <div class="echat-header">
            <div class="echat-avatar">${this.renderAvatar('bot')}</div>
            <div class="echat-header-info">
              <div class="echat-bot-name">${this.config.botName}</div>
              <div class="echat-bot-status">
                <span class="echat-status-dot"></span>
                En línea
              </div>
            </div>
            <button class="echat-close-btn" id="echat-close-btn" aria-label="Cerrar chat">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
              </svg>
            </button>
          </div>
          <div class="echat-messages" id="echat-messages"></div>
          <div class="echat-typing" id="echat-typing" style="display: none;">
            <div class="echat-typing-avatar">${this.renderAvatar('bot')}</div>
            <div class="echat-typing-dots">
              <span class="echat-typing-dot"></span>
              <span class="echat-typing-dot"></span>
              <span class="echat-typing-dot"></span>
            </div>
          </div>
          <div class="echat-input-area">
            <input type="text" class="echat-input" id="echat-input" placeholder="${this.config.placeholder}" autocomplete="off"/>
            <button class="echat-send-btn" id="echat-send-btn" aria-label="Enviar mensaje">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
              </svg>
            </button>
          </div>
          ${this.config.poweredBy ? '<div class="echat-powered">Powered by <a href="https://ecomlisto.com" target="_blank" rel="noopener">Ecomlisto</a></div>' : ''}
        </div>
      `;

            document.body.appendChild(widget);

            this.elements = {
                widget,
                bubble: document.getElementById('echat-bubble'),
                container: document.getElementById('echat-container'),
                messages: document.getElementById('echat-messages'),
                input: document.getElementById('echat-input'),
                sendBtn: document.getElementById('echat-send-btn'),
                closeBtn: document.getElementById('echat-close-btn'),
                typing: document.getElementById('echat-typing'),
                badge: document.getElementById('echat-badge'),
                teaser: document.getElementById('echat-teaser'),
                teaserText: document.getElementById('echat-teaser-text'),
                teaserClose: document.getElementById('echat-teaser-close')
            };
        }

        attachEventListeners() {
            this.elements.bubble.addEventListener('click', () => this.toggle());
            this.elements.closeBtn.addEventListener('click', () => this.close());
            this.elements.sendBtn.addEventListener('click', () => this.sendMessage());
            this.elements.input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    this.sendMessage();
                }
            });
            this.elements.input.addEventListener('input', () => {
                this.elements.sendBtn.disabled = !this.elements.input.value.trim();
            });
            this.elements.sendBtn.disabled = true;

            this.elements.teaser.addEventListener('click', (e) => {
                if (e.target.closest('.echat-teaser-close')) return;
                this.open();
            });
            this.elements.teaserClose.addEventListener('click', (e) => {
                e.stopPropagation();
                this.stopTeaser();
            });
        }

        // ---------- Bocadillos proactivos (teasers) ----------
        startTeaserCycle() {
            if (this.teaserStopped) return;
            if (!this.config.teaserMessages || this.config.teaserMessages.length === 0) return;
            this.scheduleNextTeaser();
        }

        scheduleNextTeaser() {
            const delay = this.teaserMinDelay + Math.random() * (this.teaserMaxDelay - this.teaserMinDelay);
            this.teaserTimer = setTimeout(() => {
                if (this.isOpen || this.teaserStopped) return;
                this.showTeaser();
                this.teaserTimer = setTimeout(() => {
                    this.hideTeaser();
                    this.scheduleNextTeaser();
                }, this.teaserVisibleDuration);
            }, delay);
        }

        showTeaser() {
            const msgs = this.config.teaserMessages;
            let idx;
            do {
                idx = Math.floor(Math.random() * msgs.length);
            } while (msgs.length > 1 && idx === this.lastTeaserIndex);
            this.lastTeaserIndex = idx;
            this.elements.teaserText.textContent = msgs[idx];
            this.elements.teaser.classList.add('show');
        }

        hideTeaser() {
            this.elements.teaser.classList.remove('show');
        }

        stopTeaser() {
            this.teaserStopped = true;
            if (this.teaserTimer) {
                clearTimeout(this.teaserTimer);
                this.teaserTimer = null;
            }
            this.hideTeaser();
        }

        renderAvatar(type) {
            if (type === 'bot') {
                if (this.config.botImage) {
                    return `<img src="${this.config.botImage}" alt="Bot" class="echat-avatar-img"/>`;
                }
                return this.config.botEmoji;
            } else {
                if (this.config.userImage) {
                    return `<img src="${this.config.userImage}" alt="User" class="echat-avatar-img"/>`;
                }
                return this.config.userEmoji;
            }
        }

        toggle() {
            this.isOpen ? this.close() : this.open();
        }

        open() {
            this.isOpen = true;
            this.stopTeaser();
            this.elements.bubble.classList.add('active');
            this.elements.container.classList.add('active');
            this.elements.input.focus();
            this.unreadCount = 0;
            this.elements.badge.style.display = 'none';

            if (!this.hasShownWelcome) {
                this.hasShownWelcome = true;
                setTimeout(() => this.addMessage(this.config.welcomeMessage, 'bot'), 500);
            }
        }

        close() {
            this.isOpen = false;
            this.elements.bubble.classList.remove('active');
            this.elements.container.classList.remove('active');
        }

        addMessage(text, type = 'bot') {
            this.messages.push({ id: Date.now(), text, type, timestamp: new Date().toISOString() });

            const messageEl = document.createElement('div');
            messageEl.className = `echat-message ${type}`;
            messageEl.innerHTML = `
        <div class="echat-message-avatar">${this.renderAvatar(type)}</div>
        <div class="echat-message-content">${type === 'bot' ? this.formatMessage(text) : this.escapeHtml(text)}</div>
      `;

            this.elements.messages.appendChild(messageEl);
            this.scrollToBottom();

            if (!this.isOpen && type === 'bot') {
                this.unreadCount++;
                this.elements.badge.textContent = this.unreadCount > 9 ? '9+' : this.unreadCount;
                this.elements.badge.style.display = 'flex';
            }
        }

        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        }

        // Formatear mensaje: soporta links markdown [texto](url), rutas relativas de Shopify (/products, /cart, /checkout) y URLs sueltas
        formatMessage(text) {
            const links = [];

            // 1. Links markdown [texto](url) — admite http(s) y rutas relativas que empiezan con /
            let processed = String(text).replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+|\/[^\)\s]+)\)/g, (match, label, url) => {
                const placeholder = `__ECHAT_LINK_${links.length}__`;
                links.push(`<a href="${url}" target="_blank" rel="noopener noreferrer" class="echat-link">${this.escapeHtml(label)}</a>`);
                return placeholder;
            });

            // 2. URLs sueltas (solo absolutas, para no capturar cualquier "/")
            processed = processed.replace(/(https?:\/\/[^\s<\]]+)/g, (match) => {
                const placeholder = `__ECHAT_LINK_${links.length}__`;
                links.push(`<a href="${match}" target="_blank" rel="noopener noreferrer" class="echat-link">${this.escapeHtml(match)}</a>`);
                return placeholder;
            });

            // 3. Escapar el resto del texto
            let safe = this.escapeHtml(processed);

            // 4. Reinsertar los links
            links.forEach((link, i) => {
                safe = safe.replace(`__ECHAT_LINK_${i}__`, link);
            });

            // 5. Saltos de línea
            return safe.replace(/\n/g, '<br>');
        }

        scrollToBottom() {
            this.elements.messages.scrollTop = this.elements.messages.scrollHeight;
        }

        showTyping() {
            this.isTyping = true;
            this.elements.typing.style.display = 'flex';
            this.scrollToBottom();
        }

        hideTyping() {
            this.isTyping = false;
            this.elements.typing.style.display = 'none';
        }

        async sendMessage() {
            const text = this.elements.input.value.trim();
            if (!text || this.isTyping) return;

            this.addMessage(text, 'user');
            this.elements.input.value = '';
            this.elements.sendBtn.disabled = true;
            this.showTyping();

            try {
                const response = await this.callWebhook(text);
                this.hideTyping();
                const message = this.extractMessage(response);
                this.addMessage(message, 'bot');
            } catch (error) {
                console.error('Ecomlisto Chat Error:', error);
                this.hideTyping();
                this.addMessage('Lo siento, hubo un error. Por favor, intenta de nuevo.', 'bot');
            }
        }

        extractMessage(response) {
            if (!response) return 'Mensaje recibido.';
            if (typeof response === 'string') return response;
            if (response.output) return response.output;
            if (response.response) return response.response;
            if (response.message) return response.message;
            if (response.text) return response.text;
            if (response.answer) return response.answer;
            if (response.reply) return response.reply;
            if (Array.isArray(response) && response.length > 0) return this.extractMessage(response[0]);
            return 'Mensaje recibido.';
        }

        async callWebhook(message) {
            if (!this.config.webhookUrl) {
                await this.delay(1500);
                return { response: `Gracias por tu mensaje. Este es un modo de demostración. Configura tu webhook de n8n para habilitar las respuestas reales.` };
            }

            const response = await fetch(this.config.webhookUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message,
                    sessionId: this.sessionId,
                    timestamp: new Date().toISOString()
                })
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return await response.json();
        }

        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        destroy() {
            if (this.elements.widget) this.elements.widget.remove();
        }

        setWebhookUrl(url) {
            this.config.webhookUrl = url;
        }
    }

    // ============================================
    // AUTO-INITIALIZE
    // ============================================
    function init() {
        const scripts = document.querySelectorAll('script[src*="chatbot-embed"]');
        let script = scripts[scripts.length - 1];

        if (!script) {
            script = document.currentScript;
        }

        const config = {
            webhookUrl: script?.getAttribute('data-webhook') || '',
            botName: script?.getAttribute('data-bot-name') || undefined,
            botEmoji: script?.getAttribute('data-bot-emoji') || undefined,
            botImage: script?.getAttribute('data-bot-image') || undefined,
            userImage: script?.getAttribute('data-user-image') || undefined,
            bubbleImage: script?.getAttribute('data-bubble-image') || undefined,
            welcomeMessage: script?.getAttribute('data-welcome-message') || undefined,
            placeholder: script?.getAttribute('data-placeholder') || undefined,
            poweredBy: script?.getAttribute('data-powered-by') !== 'false'
        };

        // Remove undefined values
        Object.keys(config).forEach(key => {
            if (config[key] === undefined) delete config[key];
        });

        // Merge global config (window.ecomlistoChatConfig takes precedence over data-* attributes)
        const globalConfig = window.ecomlistoChatConfig || {};
        const finalConfig = { ...config, ...globalConfig };

        window.ecomlistoChat = new EcomlistoChat(finalConfig);
    }

    // Wait for DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Export
    window.EcomlistoChat = EcomlistoChat;
})();
